import { render, staticRenderFns } from "./showYuboya.vue?vue&type=template&id=18dbc46a&scoped=true&"
import script from "./showYuboya.vue?vue&type=script&lang=ts&"
export * from "./showYuboya.vue?vue&type=script&lang=ts&"
import style0 from "./showYuboya.vue?vue&type=style&index=0&id=18dbc46a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dbc46a",
  null
  
)

export default component.exports